import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import type { useBlueprintLibrary } from './useBlueprintLibrary';
export function BlueprintDownloadDialog({
  library,
}: {
  library: ReturnType<typeof useBlueprintLibrary>;
}) {
  const pending = library.replacement;
  return (
    <Dialog
      open={!!pending}
      onClose={library.cancelReplacement}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Update {pending?.blueprint.title}?</DialogTitle>
      <DialogContent>
        <Typography>
          Download v{pending?.version} and replace your v
          {pending?.old.version || 1} copy, or keep both versions.
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 2, overflowWrap: 'anywhere' }}
        >
          {pending?.old.path.split(/[\\/]/).pop()}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Your existing file stays safe until the new download is verified.
          Modified local files are kept.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap', gap: 1, p: 2 }}>
        <Button color="inherit" onClick={library.cancelReplacement}>
          Cancel
        </Button>
        <Button onClick={() => void library.confirmReplacement(false)}>
          Keep both
        </Button>
        <Button
          variant="contained"
          onClick={() => void library.confirmReplacement(true)}
        >
          Replace
        </Button>
      </DialogActions>
    </Dialog>
  );
}
